import './App.css';
import HomePage from './pages/HomePage';
import CareerPage from './pages/CareerPage';
// import AutoPage from './pages/AutoPage'; // Import AutoPage
import Header from './components/Header';
import Footer from './components/Footer';
import AutomovtiveClientPage from './pages/AutomotiveClientPage'; // Import AutomotiveClientPage
import IMRPage from './pages/IMRPage';
import BGIMRPage from './pages/BGIMRPage';
import GMiMRPage from './pages/GMiMRPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop'; // Import the ScrollToTop component


function App() {
  return (
    <Router>
      <div className="app-layout">
        <Header />
        <div className="main-content">
          <ScrollToTop>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/careers" element={<CareerPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/auto" element={<AutomovtiveClientPage />} /> {/* Add AutoPage Route */}
            <Route path="/automotive-client" element={<AutomovtiveClientPage />} /> {/* Add AutomotiveClientPage Route */}
            <Route path="/imr" element={<IMRPage />} />
            <Route path="/bgimr" element={<BGIMRPage />} />
            <Route path="/GMiMR" element={<GMiMRPage />} />
          </Routes>
          </ScrollToTop>
         
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
